const Divider = require('components/Divider/Divider');
module.exports = Divider;
